export default class Newsticker {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.renderText();
        this.hideUnpublished();
    }
    renderText() {
        let text = JSON.parse(decodeURIComponent(this.el.getAttribute('data-text'))),
            title = JSON.parse(decodeURIComponent(this.el.getAttribute('data-title'))),
            d1 = new Date(this.el.getAttribute('data-valid-from')),
            d2 = new Date(this.el.getAttribute('data-valid-until')),
            d3 = new Date(this.el.getAttribute('data-valid-until'));
        d3.setDate(d3.getDate() + 1);
        text = text.replace(
            new RegExp('%BEGINN%', 'g'),
            this.el.hasAttribute('data-valid-from')
                ? ('0' + d1.getDate()).slice(-2) +
                      '.' +
                      ('0' + (d1.getMonth() + 1)).slice(-2) +
                      '.' +
                      d1.getFullYear()
                : '*unbestimmt*'
        );
        text = text.replace(
            new RegExp('%ENDE%', 'g'),
            this.el.hasAttribute('data-valid-until')
                ? ('0' + d2.getDate()).slice(-2) +
                      '.' +
                      ('0' + (d2.getMonth() + 1)).slice(-2) +
                      '.' +
                      d2.getFullYear()
                : '*unbestimmt*'
        );
        text = text.replace(
            new RegExp('%ENDE2%', 'g'),
            this.el.hasAttribute('data-valid-until')
                ? ('0' + d3.getDate()).slice(-2) +
                      '.' +
                      ('0' + (d3.getMonth() + 1)).slice(-2) +
                      '.' +
                      d3.getFullYear()
                : '*unbestimmt*'
        );
        let html = '';
        html += '<div class="newsticker__inner">';
        if (title != '') {
            html += '<div class="newsticker__inner-title font-h3 font-bold">';
            html += title;
            html += '</div>';
        }
        html += '<div class="newsticker__inner-text font-p font-bold">';
        html += text;
        html += '</div>';
        html += '</div>';
        this.el.innerHTML = html;
    }
    hideUnpublished() {
        /* if time passed and retailer has not published yet, remove message */
        if (this.el.hasAttribute('data-valid-until')) {
            let valid_until = new Date(this.el.getAttribute('data-valid-until')),
                now = new Date();
            valid_until.setHours(0);
            valid_until.setMinutes(0);
            valid_until.setSeconds(0);
            valid_until.setMilliseconds(0);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            now.setMilliseconds(0);
            if (now > valid_until) {
                this.el.remove();
            }
        }
    }
}
